import { ComplianceDocumentsResponse, } from '../models/asset-details-response.model';

export const COMPLIANCE_DOCUMENTS_MOCK: ComplianceDocumentsResponse[] = [
  {
    documentId: 1,
    documentName: 'Vehicle Registration',
    complianceStandard: 'SANS 1518',
    expirationDate: new Date('2025-12-03'),
    isExpired: true,
    isCompliant: false,
  },
  
  {
    documentId: 2,
    documentName: 'Insurance Certificate',
    complianceStandard: 'SANS 10231',
    expirationDate: new Date('2026-06-30'),
    isExpired: false,
    isCompliant: true,
  },
  {
    documentId: 3,
    documentName: 'Roadworthy Certificate',
    complianceStandard: 'SANS 10047',
    expirationDate: new Date('2025-08-01'),
    isExpired: true,
    isCompliant: false,
  },
  {
    documentId: 4,
    documentName: 'Pressure Test Certificate',
    complianceStandard: 'SANS 10019',
    expirationDate: new Date('2027-03-31'),
    isExpired: false,
    isCompliant: true,
  },
  {
    documentId: 5,
    documentName: 'Driver Training Certificate',
    complianceStandard: 'SANS 10231',
    expirationDate: new Date('2026-01-10'),
    isExpired: false,
    isCompliant: true,
  },
  {
    documentId: 6,
    documentName: 'Dangerous Goods Operational Agreement',
    complianceStandard: 'SANS 10231',
    expirationDate: new Date('2025-05-15'),
    isExpired: true,
    isCompliant: false,
  },
  {
    documentId: 7,
    documentName: 'Emergency Information System Placarding',
    complianceStandard: 'SANS 10232-1',
    expirationDate: new Date('2026-09-01'),
    isExpired: false,
    isCompliant: true,
  },
  {
    documentId: 8,
    documentName: 'Emergency Response Guide',
    complianceStandard: 'SANS 10232-3',
    expirationDate: new Date('2024-12-31'),
    isExpired: true,
    isCompliant: false,
  },
  {
    documentId: 9,
    documentName: 'Transport Emergency Card (TEC)',
    complianceStandard: 'SANS 10232-4',
    expirationDate: new Date('2026-11-20'),
    isExpired: false,
    isCompliant: true,
  },
  {
    documentId: 10,
    documentName: 'Dangerous Goods Classification Register',
    complianceStandard: 'SANS 10228',
    expirationDate: new Date('2027-01-01'),
    isExpired: false,
    isCompliant: true,
  }
];